const documentReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default documentReducer;